import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import ActionMenu from '../../components/ActionMenu/ActionMenu';
import ActionMenuItem from '../../components/ActionMenu/ActionMenuItem';
import Authorize from '../../components/AuthComponent/Authorize';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import Form from '../../components/Fields/Form';
import SelectListField from '../../components/Fields/SelectListField';
import TextboxField from '../../components/Fields/TextboxField';
import { FieldConfig, FormConfig } from '../../components/Fields/Types';
import useSelectListOptions from '../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import { ApplicationFunctions } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import ContactpersonModel from '../../models/ContactpersonModel';
import DataService from '../../services/data.service';
import IdParams from '../../types/IdParams';
import { DataResult } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';

const ContactpersonDetailsView: React.FC = () => {
    const genders = useSelectListOptions('api/v1/selectlist/Genders', '-- Select gender');
    const [serverErrors, setServerErrors] = useState<DataResult<ContactpersonModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<ContactpersonModel>();
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);

    let ContactpersonId: number | undefined;
    let idParams: IdParams = useParams();
    if (idParams.id && !Number.isNaN(parseInt(idParams.id))) {
        ContactpersonId = parseInt(idParams.id);
    }

    useEffect(() => {
        if (ContactpersonId !== undefined) {
            DataService.getById<ContactpersonModel>('api/v1/Contactpersons/', ContactpersonId)
                .then(response => {
                    setFormData(response);
                })
                .catch(e => {
                    if (e.response?.data?.status === 401)
                        setIsAuthorized(false);
                    else
                        handleException(e);
                });
        }
    }, [ContactpersonId]);

    function submit() {
        if (formData) {
            DataService
                .update<ContactpersonModel>(`api/v1/Contactpersons/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        setFormData(response.data);
                })
                .catch(e => handleException(e));
        }
    }

    let fields: FieldConfig[] = [
        { name: 'name', label: 'Name', validationRules: [{ type: 'isRequired' }] },
        { name: 'department', label: 'Department' },
        { name: 'genderId', label: 'Gender' },
    ];

    if (formData) {
        formData.contactInfos.forEach((value, index) => {
            fields.push({ name: 'contactInfos.' + index + '.details', label: value.contactInfoType });
        });
    }

    const formConfig: FormConfig = {
        fields: fields,
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    if (!isAuthorized)
        return (<Unauthorized />);

    if (!formData)
        return <h5 style={{ textAlign: 'center', fontWeight: 'bold' }}>Loading...</h5>;

    const formActions =
        <ActionMenu title="Actions">
            <ActionMenuItem disabled width={220} icon="fa fa-address-card-o" title="Add contact information" appFunction={ApplicationFunctions.UpdateContactperson} />
        </ActionMenu>

    return (
        <div className='main-content'>
            <Form title='Contactperson' actions={formActions} footer={(<>
                <ButtonBar offset={2}>
                    <Authorize applicationFunction={ApplicationFunctions.UpdateContactperson}>
                        <SaveButton  {...getSubmitButtonProps()} />
                    </Authorize>
                </ButtonBar>
            </>)}>
                <Container fluid>
                    <Row>
                        <Col md='12'>
                            <TextboxField {...getFieldProps('name')} />
                            <TextboxField {...getFieldProps('department')} />
                            <SelectListField {...getFieldProps('genderId')} options={genders} />
                            {formData && formData.contactInfos &&
                                formData.contactInfos.map((value, index) => {
                                    let name = 'contactInfos.' + index + '.details';
                                    return (<TextboxField {...getFieldProps(name)} />);
                                })
                            }
                        </Col>
                    </Row>
                </Container>
            </Form>
        </div>
    );
}
export default ContactpersonDetailsView;